import { DROP_STATUSES } from "@/lib/api";

const PROGRESS = "bg-sky-500/10 text-sky-300 border-sky-500/30";
const LABELS = Object.fromEntries(DROP_STATUSES);

const STYLES = {
  ordered: PROGRESS,
  arrived_pastelfix: PROGRESS,
  sorting: PROGRESS,
  shipped_areku: PROGRESS,
  arrived_areku: PROGRESS,
  packing: PROGRESS,
  collecting_initials: "bg-pink-500/10 text-pink-300 border-pink-500/40",
  open: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  closed: "bg-zinc-500/10 text-zinc-400 border-zinc-500/30",
  pending: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  rejected: "bg-red-500/10 text-red-400 border-red-500/30",
  sent: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  active: "bg-violet-500/10 text-violet-300 border-violet-500/30",
  waitlist: "bg-red-500/10 text-red-300 border-red-500/30",
  dropped: "bg-zinc-500/10 text-zinc-500 border-zinc-600/40",
  forfeited: "bg-red-500/10 text-red-300 border-red-500/30",
  won: "bg-pink-500/10 text-pink-300 border-pink-500/40",
  full: "bg-amber-500/10 text-amber-400 border-amber-500/30",
};

const TIER_STYLES = {
  GoM: "bg-amber-400/15 text-amber-200 border-amber-400/40",
  Fixed: "bg-pink-500/15 text-pink-200 border-pink-500/40",
  Soft: "bg-sky-500/15 text-sky-200 border-sky-500/40",
  Open: "bg-zinc-500/15 text-zinc-300 border-zinc-500/40",
};

export const TierBadge = ({ tier, testId, small }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full border font-bold tracking-wider uppercase ${small ? "px-1.5 text-[9px]" : "px-2 py-0.5 text-[10px]"} ${TIER_STYLES[tier] || TIER_STYLES.Open}`}>
    {tier || "Open"}
  </span>
);

export const StatusBadge = ({ status, label, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-[11px] font-semibold tracking-wider uppercase ${STYLES[status] || STYLES.closed}`}
  >
    {label || LABELS[status] || status}
  </span>
);

export const FillBar = ({ filled, total, testId, unit = "slots" }) => {
  const pct = total ? Math.round((filled / total) * 100) : 0;
  return (
    <div data-testid={testId}>
      <div className="flex justify-between text-xs text-zinc-400 mb-1.5 font-mono">
        <span>{filled}/{total} {unit}</span>
        <span>{pct}%</span>
      </div>
      <div className="h-1.5 rounded-full bg-zinc-800 overflow-hidden">
        <div className="h-full rounded-full bg-gradient-to-r from-violet-500 to-pink-500 transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export const StatTile = ({ label, value, accent = "text-white", testId }) => (
  <div className="rounded-2xl border border-white/5 bg-zinc-900/60 p-4 sm:p-5">
    <div className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">{label}</div>
    <div data-testid={testId} className={`mt-2 font-mono text-xl sm:text-2xl font-bold ${accent}`}>{value}</div>
  </div>
);

export const EmptyState = ({ title, hint, testId }) => (
  <div data-testid={testId} className="rounded-2xl border border-dashed border-zinc-800 p-10 text-center">
    <div className="font-display text-lg font-semibold text-zinc-200">{title}</div>
    {hint && <div className="text-sm text-zinc-500 mt-1">{hint}</div>}
  </div>
);
